<template>
  <div
    class="is-flex is-flex-direction-column is-align-items-center has-background-light p-5"
  >
    <span class="has-text-weight-semibold has-text-primary is-size-2">
      {{ $t('financialadvisor.not-ready-for-advisor-pro') }}
    </span>
    <span class="has-text-centered">
      {{ $t('financialadvisor.you-dont-need-subscription-to-start') }}
    </span>
    <ButtonView
      class="mt-5"
      type="is-primary"
      @click="onReferClientClicked"
      :data-e2e="FinancialAdvisorEstateCypressAttribute.planning.buttons.REFER_CLIENT"
    >
      <span class="is-primary is-size-4">
        {{ $t('financialadvisor.refer-client') }}
      </span>
    </ButtonView>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import { FinancialAdvisorEstateCypressAttribute } from '@/modules/financialadvisor/constants/FinancialAdvisorEstateCypressAttribute';

export default defineComponent({
  name: 'FinancialAdvisorReferForFreeBanner',
  emits: ['refer-client-clicked'],
  components: {
    ButtonView
  },
  static: {
    FinancialAdvisorEstateCypressAttribute
  },
  methods: {
    onReferClientClicked(): void {
      this.$emit('refer-client-clicked');
    }
  }
});
</script>
